/** 微信 WxLogin iframe 内样式（经 href data-url 注入） */
const WX_LOGIN_QRCODE_CSS = `
.impowerBox { width: 220px !important; margin: 0 auto; }
.impowerBox .qrcode { width: 168px !important; margin-top: 0; }
.impowerBox .wrp_code {
  width: 168px !important;
  height: 168px !important;
  margin: 0 auto;
}
.impowerBox .title { display: none; }
.impowerBox .info { width: 220px !important; margin: 8px auto 0; }
.status_icon { display: none !important; }
.impowerBox .status { text-align: center; margin: 0; padding: 0; }
`.replace(/\n/g, '');

export function getWxLoginStyleHref(): string {
  return `data:text/css;base64,${btoa(WX_LOGIN_QRCODE_CSS)}`;
}

/** 外层容器：限制 WxLogin iframe 占位，避免撑满登录卡片 */
export const WX_LOGIN_CONTAINER_CLASS =
  'mx-auto w-[220px] overflow-hidden [&>iframe]:mx-auto [&>iframe]:block [&>iframe]:h-[260px] [&>iframe]:w-[220px]';
